import keycloak from '@/api/keycloak'

function base64UrlEncode(str) {
    return btoa(String.fromCharCode.apply(null, new Uint8Array(str)))
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
}

function generateRandomString(length) {
    const array = new Uint8Array(length);
    crypto.getRandomValues(array);
    return Array.from(array, dec => ('0' + dec.toString(16)).substr(-2)).join('');
}

async function sha256(plain) {
    const encoder = new TextEncoder();
    const data = encoder.encode(plain);
    return await crypto.subtle.digest('SHA-256', data);
}

export async function generateRegistrationUrl(referralCode) {
    const base = `${process.env.VUE_APP_KEYCLOAK_URL}/realms/${keycloak.realm}/protocol/openid-connect/registrations`;

    const state = generateRandomString(16);
    const nonce = generateRandomString(16);
    const code_verifier = generateRandomString(64);
    const hashed = await sha256(code_verifier);
    const code_challenge = base64UrlEncode(hashed);
    const code_challenge_method = 'S256';

    const params = new URLSearchParams({
        client_id: keycloak.clientId,
        redirect_uri: process.env.VUE_APP_FRONTEND_URL,
        response_mode: 'fragment',
        response_type: 'code',
        scope: 'openid',
        ref: referralCode,
        state,
        nonce,
        code_verifier,
        code_challenge,
        code_challenge_method,
    });

    return `${base}?${params.toString()}`;
}
